import axios from 'axios';
import moment from 'moment';
import React, { Component } from "react";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';
import 'react-dialog/css/index.css';
import LoadingOverlay from 'react-loading-overlay';
// customizable method: use your own `Plotly` object
import PivotTableUI from 'react-pivottable/PivotTableUI';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
// import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
// simplest method: uses precompiled complete bundle from `plotly.js`
import Plot from 'react-plotly.js';
import { AsyncPaginate } from 'react-select-async-paginate';
import ScaleLoader from "react-spinners/ScaleLoader";
import { toast } from 'react-toastify';
import 'react-web-tabs/dist/react-web-tabs.css';
// reactstrap components
import {
  Badge, Button, Card,
  CardBody,
  CardHeader,
  Col, Collapse, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Modal, ModalHeader, Row, Table, UncontrolledDropdown
} from "reactstrap";
import TinyURL from "tinyurl";
import { Launcher } from '../../components/Chat/';
// core components
import { jobidLoad } from '../../components/Chat/UserInput';
import ChatService from '../../services/api/Chat';
import service from '../../services/api/Common';
import ProjectService from '../../services/api/Project';
import RunService from '../../services/api/Run';
import StorageService from '../../services/api/Storage';
import UserService from '../../services/api/User';
import { getImageFile, getRandomRolor, imageFileExtension, saveDownloadFile } from "../../settings/shared/commonMethod";
import constants from '../../settings/shared/constants';


// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);

const colours=['red', 'orange', 'yellow','blue', 'green', 'indigo', 'violet'];

const styles = {
  chaticon: {
    cursor: 'pointer'
  },
  chatbutton: {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    boxShadow: 'transparent',
  },
  expandStyles: {
    backgroundColor: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1
  },
  expandStyles_Comman: {
    backgroundColor: "#000000",
    color: "#2dce89",
    fontSize: "0.2rem",
    letterSpacing: 1,
    width: 550,
    height: 'auto',
    // maxHeight:400,
    marginTop: 5,
    marginLeft: 30,
    marginBottom: 2
  },
  expandStyles_param: {
    fontSize: "0.8rem",
    letterSpacing: 1,
    width: 550,
    marginTop: 5,
    marginLeft: 30
  },
  logbtn: {
    backgroundColor: "#5e72e4",
    color: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1,
    borderRadius: 8,
    height: 30,
    width: 50,
    padding: 0,
    marginLeft: 10
  },
  removedialog: {
    top: '50%',
    width: '250px'
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    borderRadius:6
  },
}

class Analyze extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      pivotState: props,
      openedCollapses: ["collapseOne", "collapseTwo", "collapseTwoCompare", "collapseTwoCompareTable"],
      dropdownOpen: false,
      input: "",
      input_user: [],
      input_userEmail: [],
      messages: [],
      open: false,
      products: [],
      columns: [],
      chatMsg: [],
      messageList:[],
      runOptions: [],
      filtered:[],
      commonOptions: [],
      updatePageNumber:0,
      totalPages:0,
      tableCompareFlag: false,
      tableCompareData:[],
      commonOptionsCompare: [],
      localName: null,
      localPhoto: null,
      socketLoadFlag: false,
      steptwoFlag: false,
      graphFlag: false,
      graphFlag_Loading: false,
      graphText: '',
      logState: false,
      runname: "",
      viewId: "",
      viewname: "",
      delimiter: "",
      chooseRunName: "",
      showuserListFlag: false,
      UserList: [],
      expanded: {},
      FilterUserList: [],
      selectedRunNames: [],
     selectedRunNamesCompare: [],
      selectedoutputFiles: [],
      selectedoutputFiles_Compare: [],
      selectedcommonAttribute: [],
      chooseJoin: "",
      chooseCommon: "",
      chooseOutput: "",
      chooseOutput_Compare: '',
      analyzeString: [],
      logDetail: [],
      count: 0,
      countPagination:0,
      copied: false,
      value: '',
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      isRunActionOpen: false,
      parasetm: [],
      modalParameter: false,
      parasetc: [],
      comparemodalParameter:false,
      chatmasterId:"",
      chatMaster:"",
      chatrundata:[],
      chatprojectdata:[],
      badgeloading:false,
      projectDTOS:[],
      tags: [],
      randomcolor:'',
      DownloadUrl:'',
      myContent:'',
      fileType:'',
      jobIds:[],
      listprojectDTOS:[],
      comparetbltext:"",
      selectedId:props,
      selectedName:props,
      tabId:props,
      selectedrow:props,
      compareRow:props,
      parentRow:[],
      sel:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
    }

    this.OpenStorageView = this.OpenStorageView.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }
  componentDidMount() {
    this.Initmethod();

this.updateWindowDimensions();
window.addEventListener('resize', this.updateWindowDimensions);

    let rowCheck =[]
if(this.state.compareRow.compareRow.length > 0){
  if(this.state.compareRow.tabId === "Compare"){
    let correctList = this.state.compareRow.compareRow;
    correctList.map((item, index) => {
      if(item.hideCodeCells === true ){
        this.setState({hideCodeCells:"yes"})
        }
       else{
        this.setState({hideCodeCells:"no"})
        }
      rowCheck.push({
        label: item.label,
         value: item.value,
         checkId:item.jobId,
         id:item.id,
         runDbId:item.runDbId,
         jobId:item.jobId,
         check:item.check,
         output: item.output,
         modalcode: item.modalcode,
         parameter: item.parameter,
         runBy: item.runBy,
         masterJobId:item.masterJobId,
         hideCodeCells:this.state.hideCodeCells
        })
    })
this.setState({chooseRunNameCompare:rowCheck,selectedRunNamesCompare:rowCheck,tableCompareFlag: true,chooseOutput_Compare:'',
 chooseOutput:'',selectedoutputFiles:[], viewId:rowCheck[0].masterJobId})
this.state.chooseRunNameCompare = rowCheck;
this.state.selectedRunNamesCompare = rowCheck;
this.state.viewId= rowCheck[0].masterJobId;
this.state.tableCompareFlag = true;
this.state.chooseOutput_Compare='';
this.state.chooseOutput='';
this.state.selectedoutputFiles=[];
 this.rentData();  // To Load compare Table
this.showotherActionCompare();
this.LoadrunsDetails(this.state.viewId)
this.state.runlength = this.state.chooseRunNameCompare.length;
  }}
else{
    this.setState({
      viewId:'',
      steptwoFlag: false,
      tableCompareFlag: false,
      tableCompareData:[],
      selectedRunNamesCompare: [],
      selectedoutputFiles_Compare: [],
      chooseRunNameCompare:[],
      graphFlag: false,
      compareRow:[]
    });
}
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
  };

  async loadOptions(search, prevOptions, { page, selvalue }) {
    let filteredOptions;
    let options = [];
    let results = [];
    let removevalues = [];
    let checkedvalues = selvalue
    if (!search) {
      filteredOptions = options;
    } else {
      const searchLower = search.toLowerCase();
      var runData = {};
      runData["jobIdOrNameStartsWith"] = searchLower
      runData["projectIds"] = []
      runData["runStatus"] = "Completed"
      const response =  await RunService.getRunSearch(runData, page, 20);
      let searchList = await response.runDetails.content !== null && await response.runDetails.content.length > 0 ? await response.runDetails.content : [];
      searchList.map((item, index) => {
          results.push({
            label: item.name + " _ " + item.jobId,
            jobId: item.jobId,
            id: item.id,
            checkId: item.jobId,
            description: item.description,
            value: item.runId,
            runDbId: item.id,
            input: item.inputSourceFiles,
            code: item.codeSourceFiles,
            output: item.modelOutputFiles,
            modalcode: item.modelOutputCodeFiles,
            parameter: item.parameterSet,
            runTime: item.runTime,
            runBy: item.createdBy,
            logEntry: item.logFiles,
            masterJobId: item.masterJobId,
            hideCodeCells: item.hideCodeCells

          })
      })
      const results_temp = results;
      const results_checked = checkedvalues;
      const filterByReference = (results_temp, results_checked) => {
        let res = [];
        res = results_temp.filter(el => {
          return !results_checked.find(element => {
            return element.jobId === el.jobId;
          });
        });
        return res;
      }
      removevalues = filterByReference(results_temp, results_checked)

      filteredOptions = removevalues.filter(({ label }) =>
        label.toLowerCase().includes(searchLower)
      );
    }
    const hasMore = filteredOptions.length > prevOptions.length + 10;
    const slicedOptions = filteredOptions.slice(
      prevOptions.length,
      prevOptions.length + 10
    );
    return {
      options: slicedOptions,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  }

  Initmethod = () =>{
    localStorage.removeItem("sharefilelink")
    localStorage.removeItem("filePathStorage")
    localStorage.removeItem("Pagehistory");
  }
  //Display Run table
  renderData(runData) {
    let runs = []
    runData.map((item, index) => {
      if(item.hideCodeCells === "true" ){
        this.setState({hideCodeCells:"yes"})
        }
       else{
        this.setState({hideCodeCells:"no"})
      }
      if (item.runStatus === "Completed") {
        runs.push({
          label: item.name + " _ " + item.jobId,
          jobId:item.jobId,
          id:item.id,
          description: item.description,
          value: item.runId,
          runDbId: item.id,
          input: item.inputSourceFiles,
          code: item.codeSourceFiles,
          output: item.modelOutputFiles,
          modalcode: item.modelOutputCodeFiles,
          parameter: item.parameterSet,
          runTime: item.runTime,
          runBy: item.createdBy,
          logEntry: item.logFiles,
          hideCodeCells:this.state.hideCodeCells
        })
      }
      if (item.runStatus === "Cancelled") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Completed") {
        this.setState({ disabled: 'disabled' });
      } else if (item.runStatus === "Failed") {
        this.setState({ disabled: 'disabled' });
      } else {
        this.setState({ disabled: 'false' });
      }
      this.state.runname = item.name;
    
    });
    this.setState({
      runOptions: runs
    });
  }

  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ pivotState: nextProps });
  }

  onDismiss = () => { };
  toggleModalParameter = (paraset) => {
    this.setState({
      modalParameter: !this.state.modalParameter,
      parasetm:paraset
    });
  };
  toggleCompareModalParameter = (parasetcompare) => {
    this.setState({
      comparemodalParameter: !this.state.comparemodalParameter,
      parasetc:parasetcompare
    });
  };
  GetRunsData = (id) => {
    let postData = {
      projectId: id
    }
      RunService.getRunbySize(postData,0,2)
      .then((res) => {
        if(res!==""){
            let size = res.runDetails.totalElements;
            RunService.getRunbySize(postData,0,size).then((response) => {
              if (response.status === 'SUCCESS') {
                let runSDTO = response.runDetails.content;
                this.setState({
                  jobIds:response.runDetails.content
                },()=>{
                  jobidLoad(this.state.jobIds);
                })
                
              } else {
                toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
              }
            });  
            }else{
        }
      })
  }
  //Get project table data
  GetParticularProjectData = (id) => {
    if (!this.state.socketLoadFlag) {
      this.setState({ loading: true });
    }
    ProjectService.GetProjectById(id).then((response) => {
      if (response.status === 'SUCCESS') {
          if(response.projectDTOS.length > 0) {
            let projectDTO = response.projectDTOS[0];
            this.state.viewname = projectDTO.name;
            this.state.chatMaster = projectDTO.chatMasterId;
          }
      }
    })
    let postData = {
      projectId: id
    }
    let size = 10;
    RunService.getRunbySize(postData,this.state.updatePageNumber,size)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let runSDTO = response.runDetails.content;
           this.renderData(runSDTO);
          this.setState({ loading: false, socketLoadFlag: false, viewId: id,totalPages:response.runDetails.totalPages,countPagination:0 });// To load table data in to product array
        } else {
          this.setState({ loading: false, socketLoadFlag: false, viewId: id,totalPages:response.runDetails.totalPages,countPagination:0 });// To load table data in to product array    
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      })
    // if (this.state.chatDbId !== null) {
    //   this.LoadChats(this.state.chatDbId);
    // }
  }
  addChip = (id,value,tags) => {
    var i= Math.floor(Math.random()*colours.length); 
    var getData = this.state.products.filter(item=>item.DbId===id);
    var index = this.state.products.findIndex(function(item, i){
      return item.DbId === id
    });
    getData[0].Tags.push(value)
    this.state.products[index]=getData[0];
    this.setState({products:this.state.products,
    randomcolor:colours[i]})
    this.CreateTags(id,tags);
  };
  getColor = () =>{
    let colorCode = getRandomRolor();
   return colorCode;
 }
  removeChip = (id,index) => {
    var getData = this.state.products.filter(item=>item.DbId===id);
    var productIndex = this.state.products.findIndex(function(item, i){
      return item.DbId === id
    });
    getData[0].Tags.splice(index,1)
    this.state.products[productIndex]=getData[0];
    this.setState({products:this.state.products})
    this.CreateTags(id,getData[0].Tags);
  };
  CreateTags = (id,tags) =>{
    RunService.createTags(id,tags)
      .then((response) => {
        if (response.status === 'SUCCESS') {
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  submitremove = (jobId) => {
    this.state.jobId = jobId;
    confirmAlert({
      title: 'Remove Job',
      message: 'Are you sure to remove this job -' + this.state.jobId + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.RemoveAction(this.state.removedialogid)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }
  updateRerun = (id, name) => {
    this.props.history.push({
      pathname: '/newProject',
      state: { mode: "reRun", rerunId: id, runName: name }
    })
  }
  cloneProject = (id,name) =>{
    this.props.history.push({
    pathname: '/newProject',
    state: { mode:"cloneProject",editId:id,editProject:name}
    })
  }
  updateItemId = (itemid) => {
    this.setState({ itemid: itemid })
    this.state.cancelitemid = itemid;
  }
  openDialog = (itemid) => {
    this.setState({ isDialogOpen: true, dialogid: itemid })
    this.state.dialogid = itemid;
  }
  updateRemoveId = (itemid) => {
    this.setState({ removeid: itemid })
    this.state.removedialogid = itemid;
  }
  // Handling remove job actions
  RemoveAction = (rid) => {
    let RemoveJobdto = {
      id: rid
    }
    RunService.removeJob(RemoveJobdto)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.GetParticularProjectData(this.state.viewId); // Reload runs data
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  handleChange = (event) => {
    this.setState({ input: event.target.value });
  }
  handleDelete = (item) => {
    var index_user = this.state.input_user.indexOf(item);
    var index_email = this.state.input_userEmail.findIndex(obj => obj['user'] === item);
    this.state.input_user.splice(index_user, 1);
    this.state.input_userEmail.splice(index_email, 1);
    this.setState({
      input_user: this.state.input_user,
      input_userEmail: this.state.input_userEmail
    })
    if (this.state.input_user.length === 0) {
      let uId = localStorage.getItem("Uid");
      this.GetAllUsers(uId);
    }
  };
  userselectedValue = (firstName, lastName, email) => {
    let myappendUser = "@" + firstName + " " + lastName
    let selectedEmail = { user: myappendUser, email: email };
    const filteredArray = this.state.UserList.filter((res) => res.firstName !== firstName);
    this.setState({
      input: "",
      input_userEmail: [...this.state.input_userEmail, selectedEmail],
      input_user: [...this.state.input_user, myappendUser],
      UserList: filteredArray
    })
  }
  clearMessages = () => {
    this.setState({ messages: [] });
  }

  handleClose = () => {
    this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false, modalParameter:false,comparemodalParameter:false})
  }
   _onScrollLoadMessage(){
    if(localStorage.getItem("scrollMount")==='false'){
       this.LoadOlderMessagesByProject(this.state.chatmasterId);
    }
  }
  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  // Hide and Show Log for each run
  HideandShowLog(flag,fileName, log) {
    this.setState({ modalloading:true ,myContent:''});
  let filepath = "jobs/"+fileName+"/logs/console.log"
    StorageService.downloadObjectUrl(filepath)
    .then((response) => {
      this.renderText(response.download_url);
      this.setState( { modalloading:false,DownloadUrl:response.download_url} );
    }).catch((error) => {
      this.setState({ modalloading:false });
    });;
    this.setState({
      logState: !flag,
      isDialogOpen: true,
      logDetails: log
    })
  }
  renderText = (url) => {
    axios.get(url)
    .then(response => {
    this.setState({
      fileType:"others",
      myContent:response.data.toString()
      })
    })
    .catch(error => {
      return error;
    });
}
  LoadrunsDetails = (vid) =>{
    if (!this.state.socketLoadFlag) {
      this.setState({ loading: true ,viewId:vid});
    }
      ChatService.GetChatRunIds(0,2)
      .then((res) => {
        if(res!==""){  // if chat response is 204 execure this condtion
          let size = res.totalItems;
          ChatService.GetChatRunIds(0,size).then((response) => {
          this.setState({chatrundata:response.chatItems},()=>{// chatrundata getting chat unread count and ## popup
             this.GetParticularProjectData(this.state.viewId);
            })
          });  
        }else{
          this.GetParticularProjectData(this.state.viewId);
        }
      })
  }

  onCloseModal = () => {
    this.setState({ open: false });
  };

  GetAllUsers = (allid) => {
    let uid = {
      id: allid
    }
    UserService.getAllUsers(this.state.usersid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
          let users = []
          let i;
          for (i = 0; i < response.userDTOS.length; i++) {
            if (loggedInUser.email !== response.userDTOS[i].email) {
              users.push(response.userDTOS[i])
            }
          }
          this.setState({
            UserList: users
          });

        } else {
        }
      })
  }

  handleChangeRun = (event) => {
    if (event !== null) {
      this.setState({
        chooseRunName: event[0].value,
        selectedRunNames: event
      });
    } else {
      this.setState({
        steptwoFlag: false,
        selectedRunNames: []
      });
    }

  }

  constructArray = (valuesArray, hidecodeArray) => {
    let tableValues = [];
    for (var cA = 0; cA < valuesArray.length; cA++) {
      let NewValue = {
        displayName: valuesArray[cA],
        hideCodeFlag: hidecodeArray[cA]
      }
      tableValues.push(NewValue)
    }
    return tableValues;
  }

  rentData = () => {
    let SelectrunIds = [];
    let SelectedJOBId = [];
    let SelectedList = [];
    this.state.parentRow =this.state.selectedRunNamesCompare;
    if(this.state.selectedRunNamesCompare.length > 0){
        for(let i=0;i<this.state.selectedRunNamesCompare.length;i++){
          SelectrunIds.push(this.state.selectedRunNamesCompare[i].id)
          SelectedJOBId.push(this.state.selectedRunNamesCompare[i].jobId)
          SelectedList.push(this.state.selectedRunNamesCompare[i])
        }
        ProjectService.CompareProject(SelectrunIds)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let tableCompareDTO = response.compareDTOS;
            const filteredRunDataFolders = tableCompareDTO.filter(item => item.keyName==="modelInputFolders");
            const filteredRunData = tableCompareDTO.filter(item => item.keyName === "name" || item.keyName ==="description" || item.keyName === "hideCodeCells"
            || item.keyName==="parameterSet" || item.keyName==="modelInputFiles" || item.keyName==="modelCodeFiles"
            || item.keyName==="modelOutputFiles" ||item.keyName==="modelOutputCodeFiles" || item.keyName==="createdBy" || item.keyName==="runTime");
            var len = filteredRunData.length;
            let hideCodesArray = filteredRunData.filter(item => item.keyName === "hideCodeCells");
            let hideCodesValuesArray = hideCodesArray[0].values;
            let tableData = [];
            for (const run of filteredRunData) {
              let tableVal = {
                keyName: run.keyName,
                values: this.constructArray(run.values, hideCodesValuesArray)
              }
              tableData.push(tableVal);
            }
            this.setState({
              tableCompareData: tableData
            },()=>{
            })
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
     });
     this.props.parentCallback(JSON.stringify(SelectedList))
    }
      else{
      this.setState({ 
        tableCompareData:[],
        tableCompareFlag: false,
        selectedRunNamesCompare:[],
        chooseRunNameCompare:[],
        compareRow:[]
      })
      this.state.tableCompareData=[]
      this.state.tableCompareFlag= false;
      this.state.selectedRunNamesCompare=[]
      this.state.chooseRunNameCompare=[]
      this.state.compareRow=[]
      this.props.parentCallback(JSON.stringify(SelectedList))

    }
  }

  handleChangeRunCompare = (event) => {
   if (event !== null) {
     if(event.length > 0){
         this.setState({
        //take 1st selected runs project to display chat
        viewId:event[0].masterJobId,
        tableCompareFlag: true,
        chooseRunNameCompare: event.value,
        chooseOutput_Compare:'',
        chooseOutput:'',
        selectedoutputFiles:[],
        selectedoutputFiles_Compare:[],
        selectedRunNamesCompare: event,
        runlength:event.length
      }, () => {
        this.rentData();  // To Load compare Table
        this.showotherActionCompare();
        this.LoadrunsDetails(this.state.viewId)
      });
    }
  }
    else {
        this.setState({
          viewId:'',
          steptwoFlag: false,
          tableCompareFlag: false,
          tableCompareData:[],
          selectedRunNamesCompare: [],
          selectedoutputFiles_Compare: [],
          graphFlag: false,
          chooseRunNameCompare:[],
          compareRow:[]
        }, () => {
           this.rentData(); 
           this.showotherActionCompare();
        });
        this.state.tableCompareData=[]
        this.state.tableCompareFlag= false;
        this.state.selectedRunNamesCompare=[]
        this.state.chooseRunNameCompare=[]
        this.state.compareRow=[]
      }
  }

  onSelectOutput = (fileName) => {
    this.setState({
      chooseOutput: fileName
    });
  }

  onSelectOutput_Compare = (fileName) => {
    this.setState({
      chooseOutput_Compare: fileName
    });
  }

  handleChangeJoin = (event) => {
    this.setState({
      chooseJoin: event.value
    });
  }
  handleChangeCommon = (event) => {
    if (event !== null) {
      this.setState({
        chooseCommon: event[0].value,
        selectedcommonAttribute: event
      });
    } else {
      this.setState({
        steptwoFlag: false,
        selectedcommonAttribute: []
      });
    }
  }
  CancelFlagTwo = () => {
    this.setState({
      products: []
    })
  }
  OpenStorageView = (name, event, hidevalue) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/runs";  
    let path = name.slice(-1) === "/"?"/storage?path="+name:"/storageView?file="+ name + "&hideCodeCells=" + hidevalue;
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }

  copyAlert = () => {
    // toast.success("Copied!");
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 

  }

  GetLink = (name, event,from) => {
    this.setState({ loading: true })
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/runs";
    let redirectUrl = currentUrl.replace(reg, "/storageView?file=" + name);

    TinyURL.shorten(redirectUrl).then((res) =>{
      this.setState({ copiedtxt: res })
      var tempInput = document.createElement("input");
      tempInput.value = this.state.copiedtxt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
        if(from === "modelinput"){
           this.setState({ copiedmodelinput: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  else if(from === "modelcode"){
           this.setState({ copiedmodelcode: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  else if(from === "modeloutputfile"){
           this.setState({ copiedmodeloutputfile: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }   else if(from === "modeloutputcodefile"){
           this.setState({ copiedmodeloutputcodefile: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }   
        else if(from === "tablecompare"){
           this.setState({ copiedtablecompare: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        }  
        else if(from === "tablecompare2"){
           this.setState({ copiedtablecompare: "Shareable link Copied" })
           setTimeout(() => {
             this.closeerror()
            },1000);
        } 
        else{
          this.setState({ comparetbltext: "Shareable link Copied" })
          setTimeout(() => {
            this.closeerror();
            this.setState({ comparetbltext: "" })

           },1000);
        }
 
    })
  }
  closeerror =() =>{
    this.setState({ loading:false,copiedmodelinput: "" ,copiedmodelcode:"", copiedmodeloutputfile:"", copiedmodeloutputcodefile:"",copiedtablecompare:"",comparetbltext:""})
}
  showotherActionCompare = () => {
    let outFiles = [];
    this.state.selectedRunNamesCompare.forEach((activity) => {
      activity.output!==null?activity.output.forEach((data) => {
        var leafName = data.split('/').pop()
        if (outFiles.indexOf(leafName) !== -1) {
        } else {
          outFiles.push(leafName);
        }
      }):console.log("");
      this.setState({
        steptwoFlag: true,
        selectedoutputFiles_Compare: outFiles
      })
    });

if(this.state.selectedRunNamesCompare.length === 0){
  this.state.tableCompareData=[]
  this.state.selectedRunNamesCompare=[]
  this.state.chooseRunNameCompare=[]
  this.state.compareRow=[]
  this.state.tableCompareFlag= false;

}
  }

  showotherAction = () => {
    let outFiles = [];
    let commonAttrip = [];
    this.state.selectedRunNames.forEach((activity) => {
      activity.output.forEach((data) => {
        if (outFiles.indexOf(data.fileName) !== -1) {
        } else {
          outFiles.push(data.fileName);
        }
      });
      this.setState({
        steptwoFlag: true,
        selectedoutputFiles: outFiles
      })
    });

    this.state.selectedRunNames.forEach((activity1) => {
      activity1.output.forEach((data) => {
        data.outputHeaders.forEach((finalData) => {
          let myUnique = commonAttrip.filter(item => item.value === finalData);
          if (myUnique.length !== 0) {
          } else {
            commonAttrip.push({
              value: finalData,
              label: finalData
            });
          }
        })
      });
      this.setState({
        commonOptions: commonAttrip
      })
    });

  }

  CompareData = () => {
    if(this.state.selectedRunNamesCompare.length > 0) {
    this.setState({
      tableCompareFlag: true,
      graphFlag_Loading: true,
      loading: true ,
      graphText: "Pivot Table Loading..."
    }, () => {
      //  this.rentData();  // To Load compare Table
    })
  }
    let dbIds = this.state.selectedRunNamesCompare.map(x => x.runDbId.toString());
    let commAttributes = this.state.commonOptionsCompare.map(x => x.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput_Compare===""?this.state.selectedoutputFiles_Compare[0]:this.state.chooseOutput_Compare,
      runName:this.state.selectedRunNamesCompare.map(x => x.runDbId.toString()),
      joinType: "outer",
      runDBIds: dbIds
    }
    this.ToLoadGraph(param)
    if(this.state.chooseRunNameCompare === []){
      this.setState({ 
        tableCompareData:[],
        tableCompareFlag: false,

      })
    }
    // this.props.parentCallback("Prabhu")

  }

  // Download compare file
  downloadCompareFile = () =>{
    let dbIds = this.state.selectedRunNamesCompare.map(x => x.runDbId.toString());
    let commAttributes = this.state.commonOptionsCompare.map(x => x.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput_Compare===""?this.state.selectedoutputFiles_Compare[0]:this.state.chooseOutput_Compare,
      runName:this.state.selectedRunNamesCompare.map(x => x.runDbId.toString()),
      joinType: "outer",
      runDBIds: dbIds
    }
    let fileName  = this.state.selectedRunNamesCompare[0].label+"_"+new Date().getTime();
    ProjectService.CompareDownload(param).then((response) => {
      saveDownloadFile(response,fileName)
     });  
  }




  SubmitJoin = () => {
    this.setState({
      graphFlag_Loading: true,
      graphText: "Pivot Table Loading..."
    });
    let dbIds = this.state.selectedRunNames.map(x => x.runDbId.toString());
    let commAttributes = this.state.selectedcommonAttribute.map(x => x.value.toString());
    let param = {
      commonAttributes: commAttributes,
      fileName: this.state.chooseOutput===""?this.state.selectedoutputFiles[0]:this.state.chooseOutput,
      runName:this.state.selectedRunNamesCompare.map(x => x.runDbId.toString()),
      joinType: this.state.chooseJoin,
      runDBIds: dbIds
    }
    this.ToLoadGraph(param)
  }

  ToLoadGraph(graphData) {
    let records = []
    let dataItems = []
    let delimiter = ","
    ProjectService.AnalyzeProject(graphData)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          delimiter = response.delimiter
          if (response.output !== null) {
            dataItems = response.output.split("\n")

            for (let i = 0; i < dataItems.length; i++) {
              let actualItems = dataItems[i].split(delimiter)
              let items = dataItems[i].split(delimiter).map(Number);
              let processedItem = []
              for (let j = 0; j < items.length; j++) {
                let value = items[j]
                if (isNaN(value)) {
                  processedItem.push(actualItems[j])
                } else {
                  processedItem.push(value)
                }
              }
              records.push(processedItem)
            }
          }
          this.setState({
            loading: false ,
            mode: 'demo',
            graphFlag: true,
            graphFlag_Loading: false,
            graphText: '',
            filename: 'Sample Dataset: Tips',
            pivotState: {
              data: records, //response.records,
              plotlyOptions: { width: 900, height: 500 },
              plotlyConfig: {},
              tableOptions: {
                clickCallback: function (e, value, filters, pivotData) {
                  var names = [];
                  pivotData.forEachMatchingRecord(filters, function (
                    record
                  ) {
                    names.push(record.Meal);
                  });
                },
              },
            },
          });


        } else {
          this.setState({
            loading: false ,
            graphFlag: false,
            graphFlag_Loading: true,
            graphText: "Pivot Table Data Failed"
          })
        }
      });
         if(this.state.chooseRunNameCompare === []){
      this.setState({ 
        tableCompareData:[],
        tableCompareFlag: false,

      })
    }
  }


  onOpenModal = () => {
    localStorage.setItem("messagePageNumber",0);
    this.setState({
      open: true,
      chatmasterId:this.state.chatMaster
    },()=>{
      this.LoadMessagesByProject(this.state.chatmasterId);
    });
  };

  LoadMessagesByProject = (chatmasterId) =>{
    this.setState({
     badgeloading:true
   })
   let size = 20;
   // Get message page number from chatwindow scroll
   ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
     if(chatResponse === "" || chatResponse === ""){  // if chat response is 204 execure this condtion
           this.setState({
             messageList: [],
             badgeloading:false
           })
     }else{
       this.setState({
         messageList: chatResponse.chat.reverse(),
         badgeloading:false
           })
     }
    });  
 }

   LoadOlderMessagesByProject = (chatmasterId) =>{
   this.setState({
     badgeloading:true
   })
   let size = 20;
   ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
       if(chatResponse === "" || chatResponse === ""){
         this.setState({
           messageList: this.state.messageList,
           badgeloading:false
         })
       }else{
         let chat = chatResponse.chat.reverse();
         for(var i=0;i<chat.length;i++){
           this.setState({
               messageList: [chat[i]].concat(this.state.messageList),
               badgeloading: false
           })
         }
       }  
    });  
 }
 displayUnreadCount (chatmasterId){
  let chatCount = 0;
  if(chatmasterId === null || chatmasterId === undefined){
     chatCount = 0;
   }else{
       var filterData = this.state.chatrundata.filter(f=>f.chatMasterId === chatmasterId);
       chatCount = filterData[0]!==undefined?filterData[0].totalUnreadMessages:0;          
     }
  return <span>{chatCount !== 0 && <sup><span className="badge badge-success">{chatCount}</span></sup>}</span>
}

async _onMessageWasSent(message) {
  let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
  let chatPayload;
  let res = {
    "firstName": loggedInUser.firstName,
    "lastName": loggedInUser.lastName,
    "photoURL": null,
    "message": message.data,
    "createdDate": moment().format(),
  }

  if (message.files.length === 0) {  // Text message
    this.setState({
      messageList: [...this.state.messageList, res],
    })
    chatPayload = {
      "messageType": message.type,
      "message": message.data,
      "mentionedUsers": message.emails,
      "chatMasterId": this.state.chatMaster
    }
    RunService.Postchat(chatPayload)
      .then((response) => { });

  } else { // media message
    res["mediaBase64Content"] = message.mediaBase64Content;
    this.setState({
      messageList: [...this.state.messageList, res],
    })
    chatPayload = {
      // "messageType": message.type,
      "message": message.data,
      // "mentionedUsers":message.emails,
      "chatMasterId": this.state.chatMaster,
      "contentType": "application/png"
    }

    ChatService.PostMedia(chatPayload, message.files)
      .then((response) => { });
  }
}

handleClick = (e) => {
  e.preventDefault();
    if(e.type === "contextmenu") {
      var arrt = e.currentTarget.getAttribute("data_attr_id");
      document.getElementById(arrt).click();
  }  
}

  render() {
    return (
      <LoadingOverlay
      
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
                <Card>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>

                  <CardBody>                  
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseOne"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseOne");
                              }}
                            >
                              Search or Select Runs to Compare &nbsp;&nbsp;

                              <i className="now-ui-icons arrows-1_minimal-down" />
                            </a>
                            { this.state.viewId !== "" &&
                              <div style={{float:"right"}}><button className="btn-icon-only text-blue" size="sm" role="button"
                                color="" style={styles.chatbutton}
                              ></button>
                                <i className="far fa-comments text-blue" onClick={e=>this.onOpenModal()} style={{cursor:"pointer",color:"#4b88da"}}/>
                                </div>
                            }
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseOne"
                            )}
                          >
                            <CardBody>
                              <Row>
                                <Col lg="5">
                                  <FormGroup>
                                    <h6 style={{ padding: "20px" }}> Step 1 - Select Runs </h6>
                                    <AsyncPaginate
                                        isMulti
                                        // closeMenuOnSelect={false}
                                        id="SelectRuns"
                                        placeholder="Search by Run Name or Run ID"
                                        loadOptions={this.loadOptions}
                                        value={this.state.chooseRunNameCompare}
                                        onChange={this.handleChangeRunCompare}
                                        additional={{
                                          page: 0,
                                          selvalue:this.state.selectedRunNamesCompare
                                        }}
                                      />
                                  </FormGroup>
                                </Col>
                                <Col lg="1">
                                </Col>
                                <Col lg="6">
                                  {this.state.selectedoutputFiles_Compare.length !== 0 && <Card>
                                    <h6 style={{ padding: "20px" }}> Output </h6>
                                    <FormGroup>
                                      <Row>
                                        <Col xs={12} >
                                          {this.state.selectedoutputFiles_Compare.map((item, index) => (
                                            <ul className="listyle" key={index}>
                                              <li><span ><input type="radio" name="input_file"
                                                onChange={e => this.onSelectOutput_Compare(item)} defaultChecked={index === 0} /><a href="# " className="text-primary" style={styles.chaticon}>&nbsp;&nbsp;&nbsp;{item}</a></span>
                                              </li>
                                            </ul>
                                          ))}
                                        </Col>
                                      </Row>
                                      <br></br>

                                    </FormGroup>
                                  </Card>}
                                </Col>

                              </Row>
                              <Row>
                                <Col lg="4">
                                 </Col>
                                <Col lg="4">
                                  <Row>
                                    <Col xs={12}>
                                      <CardBody>
                                        <div className="btns-mr-5">
                                          <FormGroup>
                                            <Button color="primary"
                                              onClick={e => this.CompareData()}
                                              size="md">Compare / Show Data </Button>
                                          </FormGroup>
                                        </div>
                                      </CardBody>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col lg="4">
                                </Col>
                              </Row>
                              <br />
                            </CardBody>
                  </Collapse>
                        </Card>
                        {/*secondend*/}
                        {/*pivot chart  start*/}
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseTwoCompare"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseTwoCompare");
                              }}
                            >
                              Data Compare &nbsp;&nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                            </a>
                            {this.state.graphFlag && <i className="fas fa-download mr-2 compare-dl-icon"  onClick={e=>this.downloadCompareFile()} />}
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseTwoCompare"
                            )}
                          >
                            {/* <CardBody>
                              <Row>
                                <Col lg="12">
                                  {this.state.graphFlag && <PivotTableUI
                                    renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}

                                    {...this.state.pivotState}
                                    onChange={s => this.setState({ pivotState: s })}
                                    unusedOrientationCutoff={Infinity}
                                  />}
                                  {this.state.graphFlag_Loading && <span style={{ justifyContent: "center", textAlign: "center" }}>{this.state.graphText}</span>}
                                </Col>
                              </Row>
                            </CardBody> */}
                              <CardBody>
                              <Row>
                                <Col lg="12">
                                <Scrollbars autoHeight  autoHeightMax={800} >
                                  {this.state.graphFlag && this.state.pivotState.data !== undefined && <PivotTableUI
                                    renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
                                    {...this.state.pivotState}
                                    onChange={s => this.setState({ pivotState: s })}
                                    unusedOrientationCutoff={Infinity}
                                  />}
                                  {this.state.graphFlag_Loading && <span style={{ justifyContent: "center", textAlign: "center" }}>{this.state.graphText}</span>}
                                  </Scrollbars>
                               </Col>
                              </Row>
                            </CardBody>

                          </Collapse>
                        </Card> 
                        {/*pivot chart  end*/}
                        {/*Table view*/}
                        <Card className="card-plain">
                          <CardHeader role="tab">
                            <a
                              aria-expanded={this.state.openedCollapses.includes(
                                "collapseTwoCompareTable"
                              )}
                              href="#pablo"
                              data-parent="#accordion"
                              data-toggle="collapse"
                              onClick={e => {
                                e.preventDefault();
                                this.collapsesToggle("collapseTwoCompareTable");
                              }}
                            >
                              Table Compare &nbsp;&nbsp;

                          <i className="now-ui-icons arrows-1_minimal-down" />
                          &nbsp;&nbsp;  <b><span style={styles.error}>{this.state.comparetbltext}</span></b>
                            </a>
                          </CardHeader>
                          <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                              "collapseTwoCompareTable"
                            )}
                          >
                            <CardBody>
                              <Row>
                                <Col lg="12">
                                &nbsp;<b><span style={styles.error}>{this.state.copiedtablecompare}</span></b> <br />
                        {this.state.tableCompareFlag === true &&
                          <Table responsive className="table-striped">
                            <tbody>
                              {this.state.tableCompareData.map((item,index1) => (
                                <tr>
                                  <th>{item.keyName === "hideCodeCells" ? " " : item.keyName}</th>
                                  {!item.keyName.includes("Files") ?
                                    item.values.map(function (iString) {
                                      return <td>{iString.displayName}</td>
                                    }) : item.values.map(function (keyPair,index2) {
                                      return <td>
                                        {keyPair.displayName.map((innerArray,index3) => (<UncontrolledDropdown  direction="right">
                                          
                                        <span className="file" data-type="file" data_attr_id={"codeId"+index1+"_"+index2+"_"+index3}
                                          onContextMenu={this.handleClick}>
                                          <div>
                                            <p className="d-flex text-primary m-0 align-items-center">
                                              <i className={getImageFile(imageFileExtension(innerArray))}></i>
                                              <p className="text-primary m-0" style={styles.chaticon}><u>{innerArray}</u>
                                              </p>
                                            </p>
                                          </div>
                                        </span>

                                          <DropdownToggle  tag="span" id={"codeId"+index1+"_"+index2+"_"+index3}></DropdownToggle>
                                          <DropdownMenu id="menu" persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem
                                              onClick={(e) => this.OpenStorageView(innerArray, e, keyPair.hideCodeFlag)} >
                                              <span >
                                                <i className="fas fa-binoculars mr-2"></i> View
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.downloadparticularFiles(innerArray, keyPair.runId, keyPair.inputType)}
                                            >
                                              <span>
                                                <i className="fas fa-download mr-2" /> Download
                                              </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.GetLink(innerArray, e, 'tablecompare2')}>
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </UncontrolledDropdown>))}</td>
                                    }, this)
                                  }
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        }
                                </Col>
                              </Row>
                            </CardBody>
                          </Collapse>
                        </Card>

                        {/*Table View end*/}
                        <Modal isOpen={this.state.open} toggle={this.onCloseModal} className="chatProjectModal"
                        backdrop="static">
                            <ModalHeader className="ModalHeader" toggle={this.onCloseModal}>Comments</ModalHeader>
                          { this.state.badgeloading === true &&  <div className="chatLoading text-center">
                            <Badge color="info" >Loading...</Badge>
                          </div>}      
                          <Launcher
                            agentProfile={{
                            }}
                            onMessageWasSent={this._onMessageWasSent.bind(this)}
                            messageList={this.state.messageList}
                            _onScrollLoadMessage={this._onScrollLoadMessage.bind(this)}
                            showEmoji
                          />                       
                        </Modal>
                  </CardBody>
                </Scrollbars>
                </Card>
           </LoadingOverlay>  
    );
  }
}

export default Analyze;
